import React from 'react'
import styled from 'styled-components';
import {MainLayout, InnerLayout} from '../styles/Layouts'
import Title from '../components/Title'
import PrimaryButton from '../components/PrimaryButton';
import ContactItem from '../components/ContactItem';
import PhoneIcon from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'
import LocationIcon from '@material-ui/icons/LocationOn'

function ContactPage() {

 const phone = <PhoneIcon/>
 const email = <EmailIcon/>
 const location = <LocationIcon/>



    return (
        <MainLayout>
            <ContactPageStyled>
            <Title title={'Contact'} span={'Contact'}/>
            <InnerLayout className={'contact-section'}>
                <div className="left-content">
                    <div className="contact-title">
                        <h4>Get In Touch</h4>
                    </div>
                   <form className="form">
                       <div className="form-field">
                            <label htmlFor="name">Enter your name*</label> 
                            <input type="text" id="name"/>
                       </div>
                       <div className="form-field">
                            <label htmlFor="email">Enter your email*</label> 
                            <input type="text" id="email"/>
                       </div>
                       <div className="form-field">
                            <label htmlFor="name">Enter your subject*</label> 
                            <input type="text" id="subject"/>
                       </div>
                       <div className="form-field">
                           <label htmlFor="text-area">Enter your message*</label>
                           <textarea name="textarea" id="textarea" cols="30" rows="10"></textarea>
                       </div>
                       <div className="form-field">
                           <PrimaryButton title={'Send Email'}/>
                       </div>
                       
                   </form>
                </div>
                <div className="right-content">
               {/* <ContactItem icon={PhoneIcon} title={'Phone'} contact1={'+13472635956'} contact2={'+77444888777'} />
               <ContactItem icon={EmailIcon} title={'Email'} contact1={'+13472635956'} contact2={'+77444888777'} />
               <ContactItem icon={LocationIcon} title={'LocationIcon'} contact1={'+13472635956'} contact2={'+77444888777'} />
                */}

                <ContactItem title={'Phone'} icon={phone} cont1={'+8613472635956'} cont2={'+8778484841'}/>
                <ContactItem title={'Email'} icon={email} cont1 ={'malorem@gmail.com'} cont2={'+lorem.ipsum@gmal.com'}/>
                <ContactItem title={'Address'} cont1={'368 Duhui Road, Minhang'} cont2={'Minhang, Shanghai'} icon={location} />
 
                </div>
            </InnerLayout>
             </ContactPageStyled>
        </MainLayout>
    )
}
const ContactPageStyled = styled.section`

 .contact-section{
     display: grid;
     grid-template-columns: repeat(2,1fr);
     grid-column-gap  :2rem;
     
     .right-content{
         display: flex;
        
         flex-direction: column;

     }
     .contact-title{
           h4{
               color:var(--white-color);
               padding: 1rem 0;
               font-size: 1.8rem;

           }
       }
     .form{
         width: 100%;
         .form-field{
             margin-top:1.2rem;
             position: relative;
             width: 100%;
             label{
                 position: absolute;
                 left: 20px;
                 top: -19px;
                 display: inline-block;
                 background-color:var(--background-dark-color);
                 padding: 0  0.5rem;
                 color: inherit;

             }
             input{
                 border:1px solid var(--border-color);
                 outline: none;
                 background: transparent;
                 height: 50px;
                 padding: 0.5rem 15px;
                 width: 100%;
                 color: inherit;

             }
             textarea{
                 background-color: transparent;
                 width: 100%;
                 color: inherit;
                 border:1px solid var(--border-color);
                 outline: none;
                 padding: 0.8rem 1rem;
             }
         }
     }
 
 
 
    }

`

export default ContactPage
